import { Component, OnInit } from '@angular/core';
import {ApiService} from "../../../utils/services/api.service";

@Component({
  selector: 'app-blank',
  templateUrl: './blank.component.html',
  styleUrls: ['./blank.component.css']
})
export class BlankComponent implements OnInit {
  private searchParams: URLSearchParams;
  public supportSmsCode;

  constructor(private apiService: ApiService,) { }

  ngOnInit() {
    this.fetchUsers();
  }

  fetchUsers() {
    this.searchParams = new URLSearchParams();
    this.searchParams.set('createdBy_Eq', "support");
    this.searchParams.set('status_Eq', "active");

    this.apiService.getSupportUsers(this.searchParams).subscribe(res => {
      this.supportSmsCode = res.data;
    }, err => {
      console.log(err)
    })
  }

}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/main/pages/blank/blank.component.ts